import MultiSelect from "../../../../Company Sub Admin/Component/CommonComponent/MultiSelect";
import { TrainingIcon } from "../TrainingIcon";

/**
 * Filter bar for the Training Dashboard. Only the Financial Year selector and the
 * Location MultiSelect are shown: the dashboard reports categorised year-to-date
 * data, so the category and time-period filters are intentionally omitted.
 */
const FilterSection = ({
    financialYear,
    financialYearId,
    onFinancialYearChange,
    selectedCategories,
    setSelectedCategories,
    categoryOptions,
    selectedPeriods,
    setSelectedPeriods,
    periodOptions,
    selectedLocations,
    setSelectedLocations,
    locationOptions,
    onClearFilters,
    activeTab,
  }) => (
    <div className="trd-filter">
      <div className="trd-filter-head">
        <h3 className="trd-filter-title">
          <TrainingIcon name="filter" size={17} />
          Training Filters
        </h3>
        <button className="trd-btn trd-btn--clear" onClick={onClearFilters}>
          <TrainingIcon name="trash" size={15} />
          Clear All Filters
        </button>
      </div>

      <div className="trd-filter-grid">
        <div className="trd-field">
          <label className="trd-label" htmlFor="trd-fy-select">
            <TrainingIcon name="calendar" size={13} />
            Financial Year
          </label>
          <select
            className="trd-select"
            id="trd-fy-select"
            value={financialYearId || ""}
            onChange={onFinancialYearChange}
          >
            <option value="">Select Financial Year</option>
            {Array.isArray(financialYear) &&
              financialYear.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.financial_year_value || item.name || `Year ${item.id}`}
                </option>
              ))}
          </select>
        </div>

        <div className="trd-field">
          <label className="trd-label">
            <TrainingIcon name="location" size={13} />
            Location
          </label>
          <MultiSelect
            options={locationOptions}
            selectedValues={selectedLocations}
            onChange={setSelectedLocations}
            placeholder="Select Locations"
            label="Location"
            activeTab={activeTab}
            labelStyle={{ display: "none" }}
            containerStyle={{ minWidth: 0 }}
            buttonStyle={{
              padding: "10px 12px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              boxShadow: "none",
              fontSize: "13px",
              fontFamily: "inherit",
            }}
          />
        </div>
      </div>
    </div>
  );

  export default FilterSection;
